import { useUserStore } from "../useUser";
import { MenuAuthenticated, MenuAuthenticatedManager, MenuWithoutAuth } from "./data";

export function getMenu() {
  const userId = useUserStore.getState().id;
  const jwt = useUserStore.getState().jwt;
  const club = useUserStore.getState().club;
  const profile = useUserStore.getState().profile;

  if (!jwt || !profile) return MenuWithoutAuth;

  if (profile === 'Criador' || profile === 'Mediador') {
    const MenuManager = MenuAuthenticatedManager(club, profile).filter((value) => value !== null);;
    return MenuManager;
  }

  return MenuAuthenticated(userId);
}